import { useState } from 'react';
import { useQuery } from 'react-query';
import { getIdFromGid } from '../utils';
import { useGlobalContext } from '../state/GlobalContext';
import {
  getSubscriptionOriginOrderFulfillments,
  rescheduleOrderFulfillment,
} from '../api';

type FulfillmentOrderStatus =
  | 'CANCELLED'
  | 'CLOSED'
  | 'INCOMPLETE'
  | 'IN_PROGRESS'
  | 'ON_HOLD'
  | 'OPEN'
  | 'SCHEDULED';

interface FulfillmentOrder {
  id: string;
  status: FulfillmentOrderStatus;
  fulfillAt: string;
}

interface OrderFulfillments {
  id: string;
  displayFulfillmentStatus: string;
  fulfillmentOrders: FulfillmentOrder[];
}

export const useOrderFulfillments = () => {
  const { customerId, subscriptionId, authToken } = useGlobalContext();
  const [isRescheduling, setIsRescheduling] = useState(false);

  const { data: orderFulfillments, isLoading, refetch } = useQuery<
    OrderFulfillments,
    Error
  >(
    ['orderFulfillments', subscriptionId],
    async () => {
      if (subscriptionId && customerId && authToken) {
        return await getSubscriptionOriginOrderFulfillments(
          customerId,
          subscriptionId,
          authToken,
        );
      }
    },
    { refetchOnWindowFocus: false },
  );

  const rescheduleFulfillment = async (id: string, fulfillAt: string) => {
    setIsRescheduling(true);
    try {
      await rescheduleOrderFulfillment(
        getIdFromGid(id) || '',
        fulfillAt,
        customerId,
        subscriptionId,
        authToken,
      );
      refetch();
    } finally {
      setIsRescheduling(false);
    }
  };

  return {
    orderFulfillments,
    isLoading: isLoading || isRescheduling,
    rescheduleFulfillment,
  };
};
